import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

interface Champion {
  DisplayName: string;
  IconHeroCard: string;
}

const HeroesLandingPage = () => {
  const [champions, setChampions] = useState<Champion[]>([]);

  const metaDescription =
    "Everything you need for Deadlock. Discover the best Deadlock builds for every hero and lane, from items to skill order and matchups, with U.GG.";

  useEffect(() => {
    fetch("https://static.bigbrain.gg/deadlock/staticdata/gamedata/cleaned_all_heroes_v2.json")
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.text();
      })
      .then((rawText) => {
        // Remove any potential BOM and normalize line endings
        const cleanedText = rawText.replace(/[\uFEFF]/g, "").replace(/\r\n/g, "\n");
        return JSON.parse(cleanedText);
      })
      .then((data) => {
        const formattedData = data.map((champ: Champion) => ({
          ...champ,
          IconHeroCard: champ.IconHeroCard.replace(
            "file://{images}",
            "https://static.bigbrain.gg/deadlock/staticdata/panorama/images",
          ).replace(".psd", "_psd.png"),
        }));
        formattedData.sort((champA: Champion, champB: Champion) => {
          const nameA = champA.DisplayName.toLowerCase();
          const nameB = champB.DisplayName.toLowerCase();
          return nameA.localeCompare(nameB);
        });
        setChampions(formattedData);
      })
      .catch((error) => console.error("Error fetching champions:", error));
  }, []);

  return (
    <div className="background-gradient">
      <div className="heroes-page-container">
        <Helmet>
          <title>Every Deadlock Hero Build - U.GG</title>
          <meta name="description" content={metaDescription} />
        </Helmet>
        <div className="main-hero-area">
          <div className="logo-area">
            <img src="https://static.bigbrain.gg/deadlock/image-assets/deadlock-heroes-page-logo.png" alt="Deadlock Logo" />
          </div>
          <div className="text-area">
            <h1>Deadlock Heroes</h1>
            <p>
              Everything you need for Deadlock. Discover the best Deadlock builds for every hero and lane, from items to skill
              order and matchups, with U.GG.
            </p>
          </div>
        </div>
        <div className="heroes-grid">
          {champions.map((champion) => (
            <Link
              key={champion.DisplayName}
              to={`/deadlock/heroes/${champion.DisplayName.toLowerCase().replace("&", "and").replace(/\s+/g, "_")}/build`}
              className="hero-card"
            >
              <div className="hero-icon-wrapper">
                <img src={champion.IconHeroCard} alt={champion.DisplayName} className="hero-icon" />
              </div>
              <div className="hero-name">
                <p>{champion.DisplayName}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HeroesLandingPage;
